<template>
  <div class="default">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
  .default {
    background: #eef4ff !important;
    min-height: 100vh;
  }
</style>

sty